import MainContainer from '@blocks/MainContainer'
import useGallery from '@customer/models/Gallery/useGallery'
import useTitle from '@hooks/useTitle'
import useMainTemplate from '@templates/Main/hooks/useMainTemplate'
import React from 'react'
import GallerySort from './components/GallerySort'
import useGalleryArchive from './hooks/useGalleryArchive'
import useGalleryComponent from './hooks/useGalleryComponent'

export default function GalleryPage() {
    const gallery = useGallery()

    useTitle("Gallery")
    useMainTemplate({ category: "gallery" })
    
    const GalleryComponent = useGalleryComponent(gallery)
    const archive = useGalleryArchive(gallery.state)
    archive.useComponent(GalleryComponent)

    return (
        <MainContainer 
            heading="Gallery" 
            box={false}
            tools={<GallerySort archive={archive} />}>
            {archive.element}
        </MainContainer>
    )
}